import axios from '@/axios'
import type { Price } from '@/types'

/**
 * Service for managing prices in the CRM
 */
export class PriceDataService {
  /**
   * Get all prices (including inactive)
   */
  getAllPrices() {
    return axios.get('/prices/all')
  }

  /**
   * Get only active prices
   */
  getActivePrices() {
    return axios.get('/prices/active')
  }

  /**
   * Get prices by category
   */
  getPricesByCategory(category: string) {
    return axios.get(`/prices/by-category/${category}`)
  }

  /**
   * Get a specific price by ID
   */
  getPrice(id: number) {
    return axios.get(`/prices/${id}`)
  }

  /**
   * Get a specific price by key
   */
  getPriceByKey(key: string) {
    return axios.get(`/prices/by-key/${key}`)
  }

  /**
   * Create a new price
   */
  createPrice(price: Partial<Price>) {
    return axios.post('/prices/create', price)
  }

  /**
   * Update an existing price
   */
  updatePrice(id: number, price: Partial<Price>) {
    return axios.put(`/prices/${id}/update`, price)
  }

  /**
   * Delete a price
   */
  deletePrice(id: number) {
    return axios.delete(`/prices/${id}`)
  }
  /**
   * Toggle price active status
   */
  togglePriceStatus(id: number, active: boolean) {
    return axios.put(`/prices/${id}/toggle-status`, { isActive: active })
  }
    /**
   * Get all available price keys
   */
  getAllPriceKeys() {
    return axios.get('/prices/keys')
  }

  /**
   * Get all unique price categories
   */
  getAllCategories() {
    return axios.get('/prices/categories')
  }
}

export default new PriceDataService()
